/**
 * @author Ryan Gladstone
 */

function GroupManageController(
  $scope,
  $state,
  $stateParams,
  $translate,
  $log,
  $window,
  groupsService,
  toastWrapperService,
  analyticsService,
  navigationService,
  confirmationDialog,
  websites,
  permissionsService,
  featureFlag
) {
  $scope.websites = websites;
  navigationService.navigateGroup('groups.group.manage');

  const { groupId } = $stateParams;

  const errorMessages = {
    simpleError: $translate.instant('ERROR'),
    groupDeleteError: $translate.instant('ERROR_DELETING_GROUP'),
    'a group with this name already exists': $translate.instant('GROUP_ALREADY_EXISTS_ERROR'),
    'missing required field "name"': $translate.instant('MISSING_REQUIRED_FIELD_NAME'),
    'no group found for the provided ID': $translate.instant('NO_GROUP_ID_FOUND'),
    'group cannot be deleted until all associated task triggers are deleted': $translate.instant('DELETE_GROUP_ERROR_1'),
    'group cannot be deleted until all associated notification subscriptions are deleted': $translate.instant('DELETE_GROUP_ERROR_2')
  };

  const translateError = message => errorMessages[message];

  groupsService.getGroup(groupId)
    .then((data) => {
      $scope.group = data;
      $scope.selectedWebsite = $scope.websites.find(site => site._id === $scope.group.website);
      $scope.newGroupName = data.name;
    }, (response) => {
      // TODO: handle rejected promise here
      $log.error('GroupManageController error: ', response);
    });

  $scope.update = () => {
    groupsService.updateGroup(groupId, { name: $scope.newGroupName, website: $scope.groupWebsite })
      .then((data) => {
        $scope.group = data;
        $scope.newGroupName = data.name;

        toastWrapperService.createToast(`${data.name} ${$translate.instant('UPDATED')}`, 'success');
        analyticsService.trackEvent('Group management', 'Updated group');
      }, (response) => {
        $log.error('GroupManageController error: ', response);
        let errorMessage;

        if (response.data && response.data.error) {
          errorMessage = translateError(response.data.error);
        }

        toastWrapperService.createToast(errorMessage || errorMessages.simpleError, 'warning');
      });
  };

  $scope.delete = () => {
    groupsService.deleteGroup(groupId)
      .then((data) => {
        toastWrapperService.createToast(`${data.name} ${$translate.instant('DELETED')}`, 'success');
        analyticsService.trackEvent('Group management', 'Deleted group');

        featureFlag.isEnabled('tasksv2').then((enabled) => {
          if (enabled) {
            $window.location.href = '/websked/1/groups';
          } else {
            $state.go('groups.list', {}, { reload: true });
          }
        });
      }, (response) => {
        let errorMessage;

        if (response.data && response.data.error) {
          errorMessage = translateError(response.data.error);
        }

        $log.error('GroupManageController error: ', response);
        toastWrapperService.createToast(errorMessage || errorMessages.groupDeleteError, 'warning');
      });
  };

  $scope.canDelete = () => $scope.group && permissionsService.isAuthorized('GD', $scope.group.website);

  $scope.confirmDeletion = () => {
    confirmationDialog.confirm('CONFIRM_DELETE_GROUP', $scope.delete);
  };

  $scope.onSelectWebsite = (id) => {
    $scope.groupWebsite = id;
  };
}

const arr = [
  '$scope',
  '$state',
  '$stateParams',
  '$translate',
  '$log',
  '$window',
  'groupsService',
  'toastWrapperService',
  'analyticsService',
  'navigationService',
  'confirmationDialog',
  'websites',
  'permissionsService',
  'featureFlag',
  GroupManageController
];

module.exports = (ngModule) => {
  ngModule.controller('GroupManageController', arr);
};
